import React, { useEffect, useState } from "react";
import SubCategoriaNoEncontrada from "./Componentes/SubCategoriaNoEncontrada";
import SubCategoriaEncontrada from "./Componentes/SubCategoriaEncontrada";

export default function SubResultadosBarraBusqueda({
  cursos = [],
  vIsFocus = false,
}) {
  const [vIsInfo, setVIsInfo] = useState(false);

  const mCrearEstilo = () => {
    if (vIsFocus) {
      if (cursos.length === 0) {
        return { height: "45px", paddingTop: "15px", paddingBottom: "15px" };
      } else {
        switch (cursos.length) {
          case 1:
            return { height: "45px", paddingTop: "10px", paddingBottom: "10px" };
          case 2:
            return { height: "90px", paddingTop: "10px", paddingBottom: "10px" };
          case 3:
            return { height: "135px", paddingTop: "10px", paddingBottom: "10px" };
          default:
            return { height: "165px", paddingTop: "10px", paddingBottom: "10px" };
            
        }
      }
    } else {
      return { height: "0px", paddingTop: "0px", paddingBottom: "0px" };
    }
  };

  return (
    <div class="box-menu-organizacion-resultados" style={mCrearEstilo()}>
      {cursos.length === 0 ? (
        <SubCategoriaNoEncontrada />
      ) : cursos.length > 0 ? (
        cursos.map((curso, index) => (
          <>
            <SubCategoriaEncontrada
              nombre={curso.nombre}
              totalCursos={curso.total_cursos}
              id={curso.id}
            />
            {cursos.length-1 !== index && (
              <div data-figma-id="5381:19932" class="linea"></div>
            )}
          </>
        ))
      ) : (
        <p>Cargando categorías...</p>
      )}
    </div>
  );
}
